import { useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_COUNTRY_RISKS_KEY } from '@/keys';
import type { CountryRisk } from '@/types/core/country-risk';

export function useGetCountryRisks(enabled = true) {
  return useQuery({
    queryKey: GET_COUNTRY_RISKS_KEY,
    queryFn: async () => (await api.get<CountryRisk[]>('/country-risks')).data,
    enabled,
  });
}
